import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PalletteProps } from '../../types/theme/pallette';
import { Wrapper } from '../../components/ProductDetail/ProductDetail.styled';
import styled from 'styled-components';

export const Card = styled.div`
  padding: 26px 30px;
  border-radius: 5px;
  background: white;
  max-width: 285px;
  width: 100%;
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobile} {
    max-width: unset;
  }
`;

export const Title = styled.h3`
  font-size: 2rem;
  color: black;
  line-height: 1.125;
  font-weight: 700;
  text-align: center;
`;

export const ModalOpenButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: unset;
  width: 100%;
`;

export const ModalWrapper = styled.div`
  display: block;
  position: fixed;
  z-index:2;
  padding-top: 130px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  @-webkit-keyframes animatetop {
    from {
      top: -300px;
      opacity: 0;
    }
    to {
      top: 0;
      opacity: 1;
    }
  }
  @keyframes animatetop {
    from {
      top: -300px;
      opacity: 0;
    }
    to {
      top: 0;
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 650px;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  ${Wrapper} {
    padding: 0px 20px;
    margin-top: 25px;
    grid-template-columns: 1fr;
    grid-gap: 0px;
    margin-bottom: 50px;
    justify-items: center;
  }
`;

export const ModalCloseButton = styled.span`
  color: ${({ theme }: PalletteProps) => theme.gray2};
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 58px;
  padding: 0px 10px;
  &:hover,
  &:focus {
    color: ${({ theme }: PalletteProps) => theme.gray3};
    text-decoration: none;
    cursor: pointer;
  }
`;

export const ModalCloseIcon = styled(FontAwesomeIcon)`
  background: none;
  border: none;
  width: 2.3rem;
  height: 2.3rem;
  font-weight: 600;
  &:hover {
    cursor: pointer;
  }
`;
